import { render, staticRenderFns } from "./SeleccionarZonaComponent.vue?vue&type=template&id=24bb84e7"
import script from "./SeleccionarZonaComponent.vue?vue&type=script&lang=js"
export * from "./SeleccionarZonaComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports